module.exports = __webpack_public_path__ + "img/gamechanger-logo-purple.f5858cb6.svg";